module.exports = __webpack_public_path__ + "fonts/6d15364.ttf";